module.exports = __webpack_public_path__ + "fonts/NanumSquareRoundL.34b53f3.ttf";